import { inject, Injectable, Injector } from '@angular/core';
import {
  ApiService,
  AppEnvironmentState,
  AuthState,
  Environment,
  UserState,
} from '@gea/digital-ui-lib';
import { Store } from '@ngxs/store';
import { BehaviorSubject, combineLatest, filter, first, map, of } from 'rxjs';

export interface MonitoringData {
  app: string;
  source: string;
  message: string;
  logLevel: LogLevel;
  env: string;
}

type LogLevel = 'INFO' | 'ERROR' | 'WARN';

@Injectable()
export class CustomMonitoringService {
  private injector = inject(Injector);

  private appName$ = new BehaviorSubject<string | undefined>(undefined);
  private api?: ApiService;
  private store?: Store;

  constructor() {
    const injector = this.injector;

    this.api = injector.get(ApiService);
    this.store = injector.get(Store);
  }

  public set appName(appName: string) {
    this.appName$.next(appName);
  }

  public sendTrackEvent(component: string, method: string) {
    combineLatest([this.store?.select(UserState.authState) ?? of(AuthState.NotSet), this.appName$])
      .pipe(
        filter(([authState, appName]) => authState === AuthState.LoggedIn && appName !== undefined),
        map(([, appName]) => appName),
        first(),
        filter((appName): appName is string => !!appName),
        map((appName: string) => this.createMonitoringData(appName, component, method)),
        filter(
          (monitoringData: MonitoringData | null): monitoringData is MonitoringData =>
            !!monitoringData,
        ),
      )
      .subscribe((monitoringData) => this.pushLogs(monitoringData));
  }

  private pushLogs(monitoringData: MonitoringData) {
    console.log('LOGGING');
  }

  private createMonitoringData(
    appName: string,
    component: string,
    method: string,
  ): MonitoringData | null {
    const env = this.store?.selectSnapshot(AppEnvironmentState.appEnvironmentState).environment;

    if (!env || env === Environment.LOCAL) {
      return null;
    }

    return {
      app: 'digital-ui-library',
      source: appName,
      message: `Component: ${component}, Method: ${method}`,
      logLevel: 'INFO',
      env: env,
    };
  }
}
